import { gql } from '@apollo/client';

export const BANK_ACCOUNT_ADDRESS_FRAGMENT = gql`
  fragment BankAccountAddressFragment on BankAccountAddress {
    id
    city
    state
    streetLine1
    streetLine2
    zipCode
  }
`;
